import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { LoggingService } from '@shs-digi-care-monorepo/frontend-lib/logging';
import { NamFeatureService } from '../../../../services/nam-feature.service';
import { NamFeature } from '../../../../services/nam-feature.model';

@Component({
    selector: 'app-settings-menu',
    templateUrl: './settings-menu.component.html',
    imports: [TranslateModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsMenuComponent {
    private readonly router: Router = inject(Router);
    private readonly logger = inject(LoggingService);
    private readonly features = inject(NamFeatureService);

    protected canManageOutOfOffice = this.features.anyEnabled(
        NamFeature.OUT_OF_OFFICE,
        NamFeature.OUT_OF_OFFICE_CALENDAR
    );

    protected openLink(link: string): void {
        switch (link) {
            case 'user-settings':
                this.router.navigate(['/settings/user']);
                break;
            case 'manage-ooo':
                this.router.navigate(['/settings/out-of-office']);
                break;
            case 'calendar-view':
                this.router.navigate(['/settings/out-of-office-calendar']);
                break;
        }
    }

    protected downloadLogs(): void {
        this.logger.downloadLogs();
    }
}
